import { getCookieItem } from "./cookieHelper"
import { KEYS_COOKIES } from "../constants/enums"
import jwt_decode from "jwt-decode"

export const getAuthToken = () => getCookieItem(KEYS_COOKIES.SESSION) || ""

export const isLoggedIn = () => {
    const token = getCookieItem(KEYS_COOKIES.SESSION)
    console.log("checking token")
    if(token) {
        console.log("has token")
        return true
        // const decoded = jwt_decode(token)
        // if(decoded?.exp) {
        //     const currentTimestamp = +(Date.now().valueOf() / 1000).toFixed(0)
        //     if(currentTimestamp < decoded?.exp) {
        //         return true
        //     }
        // }
    }else {
        console.log("no token")
        return false
    }
}
